import { __rest } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { propTypes } from './ButtonLoader.types.js';
import styles from './ButtonLoader.module.scss.js';

var ButtonLoader = function (_a) {
    var variant = _a.variant, danger = _a.danger, props = __rest(_a, ["variant", "danger"]);
    var hash = Math.floor(Math.random() * Date.now());
    var loaderClassName = clsx(styles.Loader, styles["Loader_" + variant], danger && styles["Loader_" + variant + "___danger"]);
    var getId = function (part) {
        return "spinner-" + part + "Half-" + hash + "-" + variant + "-" + danger;
    };
    return (React__default.createElement("svg", { className: loaderClassName, "data-testid": props['data-testid'] + "_loader", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "-4 -4 208 208", fill: "none" },
        React__default.createElement("defs", null,
            React__default.createElement("linearGradient", { id: getId('second') },
                React__default.createElement("stop", { offset: "0%", stopOpacity: "0", stopColor: "currentColor" }),
                React__default.createElement("stop", { offset: "100%", stopOpacity: "0.5", stopColor: "currentColor" })),
            React__default.createElement("linearGradient", { id: getId('first') },
                React__default.createElement("stop", { offset: "0%", stopOpacity: "1", stopColor: "currentColor" }),
                React__default.createElement("stop", { offset: "100%", stopOpacity: "0.5", stopColor: "currentColor" }))),
        React__default.createElement("g", { strokeWidth: "16" },
            React__default.createElement("path", { stroke: "url(#" + getId('second') + ")", d: "M 4 100 A 96 96 0 0 1 196 100" }),
            React__default.createElement("path", { stroke: "url(#" + getId('first') + ")", d: "M 196 100 A 96 96 0 0 1 4 100" }),
            React__default.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M 4 100 A 96 96 0 0 1 4 98" })),
        React__default.createElement("animateTransform", { from: "0 0 0", to: "360 0 0", attributeName: "transform", type: "rotate", repeatCount: "indefinite", dur: "1300ms" })));
};
ButtonLoader.propTypes = propTypes;

export { ButtonLoader as default };
